<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Dataset Form
        </v-card-title>
        <v-card-text>
          <form>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.id"
                label="ID">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-validate="'required|min:3'"
                data-vv-name="title"
                :error-messages="errors.collect('title')"
                v-model="item.name"
                label="Title">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-select
                dense
                label="Solr Core Name"
                small-chips
                deletable-chips
                :items="solrCoreNameCollection"
                v-model="item.solrCoreNames"
                multiple>
                </v-select>
              </v-flex>
              <v-flex xs6>
                <v-select
                label="Language"
                :items="languages"
                v-validate="'required'"
                data-vv-name="language"
                :error-messages="errors.collect('language')"
                v-model="item.language">
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout row v-if="!isNew">
              <v-flex xs12>
                <vue2-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :use-custom-dropzone-options="true"
                v-on:vdropzone-success="dropzone_success" v-on:vdropzone-error="dropzone_error"></vue2-dropzone>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="saveLoading">Cancel</v-btn>
          <v-btn color="blue-grey" class="white--text" depressed @click.native="validateBeforeSubmit(process)"  :loading="processLoading" :disabled="fileNotReady">Execute</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(save)" :loading="saveLoading" :disabled="saveDisable">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'dataset-item',
  components: {
    vue2Dropzone
  },
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    },
    solrCoreNames: {
      type: Array,
      required: false,
      default: function () { return [] }
    },
    language: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    }
  },
  created () {
    if (!this.isNew) {
      this.setLoader({
        loading: true
      })
      this.fetchDatasetItem()
    }

    this.axios.get(`/languages`)
      .then(response => {
        this.languages = response.data.map((ds) => { return {text: ds.name, value: ds.id} })
      })
      .catch(error => {
        this.handleAxiosError(error)
      })
  },
  data () {
    return {
      item: {
        id: '',
        solrCoreNames: [],
        language: undefined,
        name: ''
      },
      dropzoneOptions: { // ToDo: Update real upload endpoint
        url: new URL(`datasets/${this.id}/upload`, this.axios.defaults.baseURL).href,
        thumbnailWidth: 150,
        acceptedFiles: '.txt',
        maxFilesize: 100.0,
        maxThumbnailFilesize: 100.0,
        headers: { 'Authorization': `${this.$auth.token()}` },
        addRemoveLinks: false
      },
      uploaded_filename: null,
      cname: null,
      file_size: 0,
      saveLoading: false,
      processLoading: false,
      fileNotReady: true,
      languages: [],
      saveDisable: false
    }
  },
  computed: {
    isNew () {
      return this.id == null || this.id === ''
    },
    ...mapState({
      solrCoreNameCollection: state => state.configurations.solrCoreNames
    })
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    dropzone_success (file, response) {
      this.uploaded_filename = response.filename
      this.cname = response.cname
      this.file_size = file.size / 1000
      this.fileNotReady = false
      this.saveDisable = true
      this.setSnack({
        message: 'Your file has been uploaded successfully! Click Execute to process it.',
        type: 'success',
        timeout: 6000
      })
    },
    dropzone_error (file, message, xhr) {
      var m = null
      this.$refs.myVueDropzone.removeAllFiles()
      this.uploaded_filename = null
      this.cname = null
      this.file_size = 0
      this.fileNotReady = true
      this.saveDisable = false
      if (message.error_description != null) {
        m = message.error_description
      } else {
        m = message
      }
      this.setSnack({
        message: m,
        type: 'error',
        timeout: 4000
      })
    },
    fetchDatasetItem () {
      this.axios.get(`/datasets/${this.id}`)
        .then(response => {
          this.setDatasetItem(response.data)
        })
        .catch((error) => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    setDatasetItem (item) {
      this.item = this.mapDatasetItem(item)
    },
    mapDatasetItem (item) {
      if (item.status === 'Processing' || item.status === 'Fetching from Solr') {
        this.saveDisable = true
      }
      return {
        id: item.id,
        solrCoreNames: item.solr_core_names,
        language: item.language.id,
        name: item.name
      }
    },
    process () {
      if (this.uploaded_filename == null) {
        this.setSnack({
          message: ' Please upload the text file.',
          type: 'error'
        })
      } else {
        this.processLoading = true
        let itemToSave = {
          filename: this.uploaded_filename,
          cname: this.cname
        }

        this.$refs.myVueDropzone.removeAllFiles()
        this.axios.post(`/datasets/${this.id}/import`, itemToSave)
          .then(response => {
            this.setSnack({
              message: `File size is ${this.file_size} MB. It may take a while to process it!`,
              type: 'success',
              timeout: 6000
            })
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.$refs.myVueDropzone.removeAllFiles()
            this.processLoading = false
            this.uploaded_filename = null
            this.cname = null
            this.file_size = 0
            this.fileNotReady = true
            this.saveDisable = false
          })
      }
    },
    save () {
      this.saveLoading = true
      let itemToSave = {
        solr_core_names: this.item.solrCoreNames,
        language: this.item.language,
        name: this.item.name
      }

      if (this.isNew) {
        this.axios.post('/datasets', itemToSave)
          .then(response => {
            this.$toast.open({text: 'Dataset successfully saved.', type: 'success'})
            this.$router.replace({name: 'datasetEditForm', params: {id: response.data.id}})
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        this.axios.put(`/datasets/${this.item.id}`, itemToSave)
          .then(response => {
            this.$toast.open({text: 'Dataset successfully saved.', type: 'success'})
          })
          .catch((error) => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      }
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack',
      setLoader: 'loader/setLoader'
    })
  },
  watch: {
    saveLoading (val) {
      this.setLoader({
        loading: val
      })
    },
    processLoading (val) {
      this.setLoader({
        loading: val
      })
    }
  }
}
</script>

<style>

</style>
